/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/groupService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

/**
 * 用户列表
 */
export function getGroupData(Info) {
  return request({
    url:
      "/api/v1/groups?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建group页面数据
 */
export function createGroup(data) {
  return request({
    url: "/api/v1/groups",
    method: "POST",
    data: data
  });
}
/*
 * 编辑groups页面数据
 */
export function editGroup(data) {
  return request({
    url: "/api/v1/groups/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取group数据详情
 */
export function getGroupInfo(id) {
  return request({
    url: "/api/v1/groups/" + id,
    method: "GET"
  });
}
/*
 * 删除group数据
 */
export function deleteGroup(id) {
  return request({
    url: "/api/v1/groups/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/groupService.js